import React, { useState } from 'react'
import { Pane, TextInput, Label, Button } from '@leverege/ui-elements'
import { useValueChange } from '@leverege/ui-hooks'

import ModuleModel from './ModuleModel'

import S from './ModuleEditor.css'

export default function ModuleEditor( props ) {

  const { isCreate, isEditable = true, value : model, onChange, eventData } = props
  const [ showDialog, setShowDialog ] = useState( false )
  const onModelChange = useValueChange( ModuleModel, props )
  
  if ( model == null ) {
    return (
      <Pane variant="padding">
        No Module Selected
      </Pane>
    )
  }
  const isCustom = ModuleModel.getScope( model ) === 'custom'
  const isNew = model.createdAt == null

  return (
    <Pane variant="editor|padding">
      <div className={S.grid}>
        <Label variant="input">Name</Label>
        <TextInput
          hint="Unique Module Name"
          variant="role"
          value={ModuleModel.getName( model )}
          size={30}
          eventData="setName"
          disabled={!isEditable || !isCustom || !isNew}
          autoFocus
          onChange={onModelChange}/>
        <Label variant="input">Display Name</Label>
        <TextInput
          variant="role"
          value={ModuleModel.getDisplayName( model )}
          size={30}
          eventData="setDisplayName"
          disabled={!isEditable}
          onChange={onModelChange}/>
        <Label variant="input">Category</Label>
        <TextInput
          variant="role"
          value={ModuleModel.getCategory( model )}
          size={30}
          eventData="setCategory"
          disabled={!isEditable || !isCustom}
          onChange={onModelChange}/>
        <Label variant="input">Description</Label>
        <TextInput
          variant="role"
          value={ModuleModel.getDescription( model )}
          size={30}
          eventData="setDescription"
          disabled={!isEditable}
          onChange={onModelChange}/>
      </div>
    </Pane>
  )
}
